import React from 'react'
import { TabItem } from '../tab-item'
import { useViewport } from '../../utils'

const ListNav = ({tabs, activeTab, onChange, className}) => {
  const { isDesktop } = useViewport()

  return isDesktop ? (
    <div className={`flex border-b mb-10 ${className}`}>
      {
        tabs.map((t, index) => {
          const className = index === 0 ? '' : 'ml-6'
          return <TabItem
            key={index}
            selected={activeTab}
            onClick={onChange}
            text={t}
            className={`pb-4 ${className}`}
            small
          />
        })
      }
    </div>
  ) : (
    <div className={`flex border-b mb-8 w-full overflow-x-auto ${className}`}>
      {
        tabs.map((t, index) => {
          return <TabItem
            key={index}
            selected={activeTab}
            onClick={onChange}
            text={t}
            className={`whitespace-no-wrap p-4`}
            embed
          />
        })
      }
    </div>
  )
}

export { ListNav }
